import styled from 'styled-components';
import Icon from './Information1';

const InformationIcon = styled(Icon)`
  cursor: pointer;
`;

export default InformationIcon;
